import { Route, Routes } from "react-router-dom";

import PriceRemarkSettings from "./list";

export default function PriceRemarkSettingsRoutes() {
  return (
    <Routes>
      <Route path="/" element={<PriceRemarkSettings />} />
    </Routes>
  );
}
